import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ProcessElementsResource } from "core/stages-client";
import { ViewService } from "core/view.service";
import { ProcessComplianceAssociationStore } from "process/compliance/associations/process-compliance-association-store.logic";
import { ProcessComplianceAssociationService } from "process/compliance/associations/process-compliance-association.service";

@Injectable({ providedIn: "root" })
export class ProcessComplianceAssociationStoreResolver implements Resolve<ProcessComplianceAssociationStore> {
	constructor(
		private viewService: ViewService,
		private associationService: ProcessComplianceAssociationService,
		private processElementsResource: ProcessElementsResource,
	) {}

	resolve(): ProcessComplianceAssociationStore {
		return new ProcessComplianceAssociationStore(
			this.viewService,
			this.associationService,
			this.processElementsResource,
		);
	}
}
